import React from 'react';
import Table from '../Table/Table';
import style from './ValuationAndMultiples.module.css';


const ValuationAndMultiples = ({ valuation = {} }) => {
  return (
    <div>
      <h3 className={style.headline}>Valuation & Multiples</h3>
      <div>
        <Table>
          <tbody>
            <tr>
              <th>P/E Ratio</th>
              <td className={style.points}>{valuation["pe_ratio"] ?? '-'}</td>
            </tr>
            <tr>
              <th>PEG</th>
              <td className={style.points}>{valuation["peg_ratio"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Price to Sales</th>
              <td className={style.points}>{valuation["price_to_sales"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Price to Book Ratio</th>
              <td className={style.points}>{valuation["price_to_book"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Enterprise Value to Revenue</th>
              <td className={style.points}>{valuation["revenue_to_enterprise_value"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Enterprise Value to EBIT</th>
              <td className={style.points}>{valuation["ebit_to_enterprise_value"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Enterprise Value to Net Income</th>
              <td className={style.points}>{valuation["enterprise_value_to_net_income"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Total Debt to Enterprise</th>
              <td className={style.points}>{valuation["total_debt_to_enterprise_value"] ?? '-'}</td>
            </tr>
            <tr>
              <th>Debt to Equity</th>
              <td className={style.points}>{valuation["debt_to_equity"] ?? '-'}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ValuationAndMultiples;
